import { IInternalAuth } from '../interfaces/inversifyDi'
import { LearningTrack, LearningTrackStep, LearningTrackTag, LatestTrackStep } from '../interfaces/LearningTrack'
import { container, TYPES } from '../inversifyconfig/container.config'
import { ProcessHttp } from '../helpers/Auth'
import LearningTracksAction from '../redux/actions/learningTracks/LearningTracksAction'
import { IHttpRequest } from  '@/interfaces/IHttp'

class LearningTracksWebService {
  
  router = store => dispatch => action => {
    switch (action.type) {

      case LearningTracksAction.REQUEST_LEARNING_TRACKS:

        // If doest have token
        if (!ProcessHttp()){
          return dispatch(action)
        }

        // Get shortcode - should be global 
        let shortcode = window.location.host.split('.')[0];

        if (process.env.NODE_ENV === "development"){
          shortcode= "tab"
        }

        this.internalAuth().Check().then(() => { 

          this.httpRequest().get(
            `/thrivetracks/gettracks?shortcode=${shortcode}`
          ) 
          .then((x) => {
            let tracks = x.data.tracks.map(item => new LearningTrack(
              item.track.id, 
              item.track.title, 
              item.track.synopsis, 
              item.track.tag, 
              item.track.image, 
              null, 
              item.progress
            ))
            let latestTrackStep = null
            // We receive an empty object from the server with null for every field
            if (x.data.latestTrackStep.trackStep.title !== null) {
              latestTrackStep = new LatestTrackStep(
                x.data.latestTrackStep.trackTitle, 
                x.data.latestTrackStep.trackStep.trackId, 
                new LearningTrackStep(
                  x.data.latestTrackStep.trackStep.id,
                  x.data.latestTrackStep.trackStep.title,
                  x.data.latestTrackStep.trackStep.synopsis,
                  x.data.latestTrackStep.trackStep.image,
                  x.data.latestTrackStep.trackStep.content,
                  x.data.latestTrackStep.trackStep.order,
                  0
                )
              )            
              latestTrackStep.step.order = x.data.latestTrackStep.trackStep.order
            }
            store.dispatch(LearningTracksAction.receiveLearningTracks(tracks))
            store.dispatch(LearningTracksAction.receiveLatestTrackStep(latestTrackStep))
            store.dispatch(LearningTracksAction.setIntroModalStatus(x.data.showIntroModal))
            store.dispatch(LearningTracksAction.setOrgAdminStatus(x.data.isOrgAdmin))

          })
          .catch((e) => {
            console.error(e.message)
          })
        })

      return dispatch(action)

      case LearningTracksAction.REQUEST_LEARNING_TRACK_STEPS:

        // If doest have token
        if (!ProcessHttp()){
          return dispatch(action)
        }

        this.internalAuth().Check().then(() => { 
          this.httpRequest().get(
            `/thrivetracks/getsteps?trackId=${action.payload.trackId}`
          )   
          .then((x) => {
            let steps = x.data.map(item => new LearningTrackStep(
              item.id, 
              item.title, 
              item.synopsis, 
              item.image, 
              null, 
              item.complete,
              item.order
            ))
            store.dispatch(LearningTracksAction.receiveLearningTrackSteps(action.payload.trackId, steps))
          })
          .catch((e) => {
            console.error(e.message)
          })
        })
      return dispatch(action)

      case LearningTracksAction.MARK_LEARNING_TRACK_STEP_AS_COMPLETE:

        // If doest have token
        if (!ProcessHttp()){
          return dispatch(action)
        }

        this.internalAuth().Check().then(() => { 
          this.httpRequest().get(
            `/thrivetracks/completestep?stepId=${action.payload.step.id}`
          )
          .then((x) => {
            store.dispatch(LearningTracksAction.requestLearningTracks())
          })
          .catch((e) => {
            console.error(e.message)
            store.dispatch(LearningTracksAction.rejectLearningTrackStepAsComplete(action.payload.track, action.payload.step))
          })
        })
      return dispatch(action)
    
      case LearningTracksAction.UNDO_MARK_LEARNING_TRACK_STEP_AS_COMPLETE:

        // If doest have token
        if (!ProcessHttp()){
          return dispatch(action)
        }

        this.internalAuth().Check().then(() => { 
          this.httpRequest().get(
            `/thrivetracks/UndoCompleteStep?stepId=${action.payload.step.id}`
          )
          .then((x) => {
            store.dispatch(LearningTracksAction.requestLearningTracks())
          })
          .catch((e) => {
            console.error(e.message)
            store.dispatch(LearningTracksAction.rejectLearningTrackStepAsComplete(action.payload.track, action.payload.step))
          })
        })
      return dispatch(action)

      case LearningTracksAction.REQUEST_LEARNING_TRACK_STEP:

        // If doest have token
        if (!ProcessHttp()){
          return dispatch(action)
        }

        this.internalAuth().Check().then(() => {

          this.httpRequest().get(
            `/thrivetracks/getsinglestep?stepId=${action.payload.stepId}`
          )
          .then((x) => {
            let step = new LearningTrackStep(
              x.data.currentStep.trackStep.id, 
              x.data.currentStep.trackStep.title, 
              x.data.currentStep.trackStep.synopsis,
              x.data.currentStep.trackStep.image,
              x.data.currentStep.trackStep.content,
              x.data.currentStep.complete,
              x.data.currentStep.order
            )
            step.order = x.data.currentStep.order
            if (x.data.nextStep.title !== null) {
              step.nextStepOverview = x.data.nextStep
            }
            if (x.data.prevStep.title !== null) {
              step.previousStepOverview = x.data.prevStep
            }
            store.dispatch(LearningTracksAction.receiveLearningTrackStep(x.data.currentStep.trackStep.trackId, step))
          })
          .catch((e) => {
            console.error(e.message)
          })
        })
      return dispatch(action)

      case LearningTracksAction.SET_INTRO_MODAL_VIEWED:

        // If doest have token
        if (!ProcessHttp()){
          return dispatch(action)
        }

        this.internalAuth().Check().then(() => { 
          this.httpRequest().get(
            `/thrivetracks/IntroModalSeen`
          )    
        })
        return dispatch(action)

      default:
        return dispatch(action)
    }
  }
  
  httpRequest() {

    let httpRequest = container.get<IHttpRequest>(TYPES.IHttpRequest);

    // No cache
    httpRequest.setHeaders({
      'Cache-control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0'           
    });
    
    return httpRequest;
  }

  internalAuth() {
    return container.get<IInternalAuth>(TYPES.IInternalAuth)
  }
}

export default LearningTracksWebService